
<template>
  <div>
    <el-dialog
      title="竞代数据编辑"
      class="changeStatus"
      width="800px"
      top="5vh"
      :visible.sync="visible"
      @close="closeDialog"
    >
      <div class="jdedit">
        <el-form ref="form" :model="form" label-width="130px" label-position="left">
          <el-form-item label="操作类型：">
            <el-radio-group v-model="form.dataType">
              <el-radio label="数据编辑"></el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="des">填充的数据会覆盖至所选的所有覆盖周期内，每一天的数据都一致</div>
          <el-form-item label="覆盖周期">
            <el-col :span="14">
              <el-date-picker
                v-model="form.date"
                type="daterange"
                align="left"
                unlink-panels
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="changeTime"
                :picker-options="pickerOptions"
                clearable
              ></el-date-picker>
            </el-col>
          </el-form-item>
        </el-form>

        <div>
          <el-form :model="paramsForm" ref="formRef" :rules="paramsForm.paramsRules">
            <el-table :data="paramsForm.params" style="width: 100%" height="230">
              <el-table-column label="竞代名称" align="left" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.plat_username}}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="整体消耗">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'params.' + scope.$index + '.overall_cost'"
                    :rules="paramsForm.paramsRules.overall_cost"
                  >
                    <el-input
                      v-model="scope.row.overall_cost"
                      placeholder="请输入1-8位数字"
                      size="small"
                      @input="inputVal"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="IAA消耗" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'params.' + scope.$index + '.iaa_cost'"
                    :rules="paramsForm.paramsRules.iaa_cost"
                  >
                    <el-input
                      v-model="scope.row.iaa_cost"
                      placeholder="请输入1-8位数字"
                      size="small"
                      @input="inputVal"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="IAP消耗" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'params.' + scope.$index + '.iap_cost'"
                    :rules="paramsForm.paramsRules.iap_cost"
                  >
                    <el-input
                      v-model="scope.row.iap_cost"
                      placeholder="请输入1-8位数字"
                      size="small"
                      @input="inputVal"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column label="小游戏消耗" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'params.' + scope.$index + '.game_cost'"
                    :rules="paramsForm.paramsRules.game_cost"
                  >
                    <el-input
                      v-model="scope.row.game_cost"
                      placeholder="请输入1-8位数字"
                      size="small"
                      @input="inputVal"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeSure()">取 消</el-button>
          <el-button type="primary" @click="saveForm()">保 存</el-button>
        </span>
      </div>
    </el-dialog>

    <el-dialog title="友情提示" :visible.sync="yqtsVisible" width="500px">
      <span>覆盖日期中包含有数据日期，您确定要修改吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="closeSummit">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>



<script>
import API from "@/api/competeManage.js";

export default {
  props: {
    pageFuncNames: {
      type: Array,
      default: () => {
        return [];
      }
    },
    platId: {
      type: String,
      default: ""
    }, // 渠道id
    rldata: {
      type: Object,
      default: () => {
        return {};
      }
    }, // 日历点击对象
    dataDay: {
      type: [Object, Array],
      default: () => {
        return {};
      }
    } // 竞代名称对象
  },
  data() {
    return {
      isCheckLoading: false, //校验提交进度条
      paramsForm: {
        params: [
          {
            plat_username: "",
            plat_username_id: ""
            // overall_cost: "ssss",
            // iaa_cost: "3",
            // iap_cost: "s",
            // game_cost: "",
          }
        ],
        paramsRules: {
          overall_cost: [
            { required: false, message: "请输入整体消耗", trigger: "change" },
            {
              pattern: /^[0-9]\d{0,7}(\.\d{0,2})?$/,
              message: "仅支持数字，两位小数",
              trigger: "change"
            }
          ],
          iaa_cost: [
            { required: false, message: "请输入IAA消耗", trigger: "change" },
            {
              pattern: /^[0-9]\d{0,7}(\.\d{0,2})?$/,
              message: "仅支持数字，两位小数",
              trigger: "change"
            }
          ],
          iap_cost: [
            { required: false, message: "请输入IAP消耗", trigger: "change" },
            {
              pattern: /^[0-9]\d{0,7}(\.\d{0,2})?$/,
              message: "仅支持数字，两位小数",
              trigger: "change"
            }
          ],
          game_cost: [
            { required: false, message: "小游戏消耗", trigger: "change" },
            {
              pattern: /^[0-9]\d{0,7}(\.\d{0,2})?$/,
              message: "仅支持数字，两位小数",
              trigger: "change"
            }
          ]
        }
      },

      modelForm: {
        account_list: []
      },
      yqtsVisible: false,
      form: {
        dataType: "数据编辑",
        date: ""
      },
      //   plat_id: "", // 渠道id
      is_data: "0", //是否覆盖，0 无数据覆盖，1 有数据覆盖
      account_list: [],
      visible: false,
        pickerOptions: {
            firstDayOfWeek: 1,
        },
    };
  },
  watch: {
    dataDay(val) {
      this.dataDay = val;
      this.writeData();
    }
  },

  mounted() {},
  methods: {
    inputVal(e) {
      console.log(e);
      this.$forceUpdate();
    },
    // 重绘组合数据,父组件传参是值加入其他4个对象属性
    writeData() {
      //   console.log("加载", "rldata", this.rldata, "dataDay", this.dataDay);
      if (this.rldata && this.rldata.day) {
        this.form.date = [this.rldata.day, this.rldata.day];
      }

      this.account_list = (this.dataDay && this.dataDay["account_list"]) || [];
      let bbb = [];
      if (this.account_list) {
        this.account_list.forEach((item, index) => {
          let newObj = Object.assign({}, item, {
            plat_username_id: item["plat_username_id"],
            plat_username: item["plat_username"],
            overall_cost: "",
            iaa_cost: "",
            iap_cost: "",
            game_cost: ""
          });
          bbb.push(newObj);
        });
      }

      this.paramsForm.params = bbb;
    },
    // 展示弹窗
    showDialog(data) {
      this.writeData();

      this.visible = true;
    },
    closeDialog() {
      this.visible = false;
      let options={
        plat_id: this.platId,
        range_time: `${this.form.date[0]}/${this.form.date[1]}`,
      }
      this.$emit("upDataList", options,"编辑刷新日历");
    },
    //取消确认
    closeSure() {
      this.$refs.formRef.resetFields();
      this.$refs.formRef.clearValidate();
      this.visible = false;
    },
    //修改时间
    changeTime(e) {
      console.log(e);
    },

    closeSummit() {
      this.yqtsVisible = false;
      console.log("取消覆盖");
    },

    // 点击确定提交接口
    submitForm() {
      // 默认提价参数数据
      let submitArray = {
        
        plat_username_id: "",
        overall_cost: "",
        iaa_cost: "",
        iap_cost: "",
        game_cost: ""
      };
        //存储原数据
     let newParams= JSON.parse(JSON.stringify(this.paramsForm.params) )
      // 遍历获取form对象。筛选对象中与提价数据不相符的值进行剔除
      let newArr = newParams.map((item, index) => {
        Object.keys(item)
          .filter(key => !(key in submitArray))
          .forEach(key => delete item[key]);
        return item;
      });
      // 筛选不为空的数据
      let bbb = newArr.filter((item, index) => {
        return (
          item.overall_cost || item.iaa_cost || item.iap_cost || item.game_cost
        );
      });

      let options = {
        plat_id: this.platId,
        range_time: `${this.form.date[0]}/${this.form.date[1]}`,
        cost_data: JSON.stringify(bbb)
      };
      console.log(options);

      API.createCompeteData(options).then(
        res => {
          let resData = res.data;
          this.yqtsVisible = false;
          this.visible = false;
          this.$message({
            message: "恭喜你,数据覆盖成功！",
            type: "success"
          });
        },
        err => {
          this.yqtsVisible = false;
          this.visible = false;
          this.$message({
            message: "非常抱歉,数据覆盖失败！",
            type: "error"
          });
          console.log("err", err);
        }
      );
    },

    // 点击保存按钮，先校验是否覆盖再提交
    saveForm() {
        //保存校验
      this.$refs.formRef.validate(valid => {
        if (valid) {
          // 如果校验通过。调用 是否覆盖接口
          if (this.isCheckDataCommit()) {
            this.isDataCover();
          }
        } else {
          this.$message({
            message: "请您修改不符合规则的输入项！",
            type: "error"
          });
        }
      });
    },

    // 校验提交数据符合提交规则

    isCheckDataCommit() {
      let isCheck = true; // 确认是否通过校验。 通过为true，不通过为false

      for (let index in this.paramsForm.params) {
        let item = this.paramsForm.params[index];
        console.log(item);
        let all_cost =
          Number(item.iaa_cost) +
          Number(item.iap_cost) +
          Number(item.game_cost);

        // console.log("3个和===", all_cost);

        // if (
        //   !(
        //       Number(item.overall_cost) ||
        //     Number(item.iaa_cost) ||
        //     Number(item.iap_cost) ||
        //     Number(item.game_cost)
        //   )
        // ) {
        //   this.$message({
        //     message: `[ ${item.plat_username} ]` + "最少要有一个消耗！",
        //     type: "warning"
        //   });
        //   isCheck = false;
        //   break;
        // }
        // if (
        //   item.overall_cost == "" &&
        //   item.iaa_cost == "" &&
        //   item.iap_cost == "" &&
        //   item.game_cost == ""
        // ) {
        //   this.$message({
        //     message: `[ ${item.plat_username} ]` + "最少要有一个消耗！",
        //     type: "warning"
        //   });
        //   isCheck = false;
        //   break;
        // }
        if (
          item.overall_cost == "" &&
          !(item.iaa_cost == "" && item.iap_cost == "" && item.game_cost == "")
        ) {
          item.overall_cost = all_cost;
        }

        if (Number(item.overall_cost) < all_cost) {
          this.$message({
            message:
              `[ ${item.plat_username} ]` +
              "IAA+IAP+小游戏的消耗 不可大于整体消耗！",
            type: "warning"
          });
          isCheck = false;
          break;
        }
      }
      return isCheck;
    },
    // 是否覆盖
    isDataCover() {
      let submitArray = {
        plat_username_id: "",
        overall_cost: "",
        iaa_cost: "",
        iap_cost: "",
        game_cost: ""
      };
      //存储原数据
      let newParams= JSON.parse(JSON.stringify(this.paramsForm.params) )
      // 遍历获取form对象。筛选对象中与提价数据不相符的值进行剔除
      let newArr =newParams.map((item, index) => {
        Object.keys(item)
          .filter(key => !(key in submitArray))
          .forEach(key => delete item[key]);
        return item;
      });
      // 筛选不为空的数据
      let bbb = newArr.filter((item, index) => {
        return (
          item.overall_cost || item.iaa_cost || item.iap_cost || item.game_cost
        );
      });

      let options = {
        plat_id: this.platId,
        range_time: `${this.form.date[0]}/${this.form.date[1]}`,
        cost_data: JSON.stringify(bbb)
      };
      console.log(options);

      API.dataCheck(options).then(
        res => {
          let resData = res.data;
          this.is_data = resData.is_data;
          if (resData.is_data == 0) {
            this.submitForm();
          } else {
            this.yqtsVisible = true;
          }
        },
        err => {
          this.$message.error(err.info || "校验是否有覆盖数据失败！");
        }
      );
    },
    // 校验提交的loading
    handleCheck() {
      this.isCheckLoading = this.$loading({
        lock: true,
        text: "竞代数据编辑提交中，请等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    }
  }
};
</script>

<style lang="scss">
.changeStatus {
  .el-dialog__header {
    // background-color: #02a7f0;
  }
}

.jdedit {
  width: 100%;

  .el-form-item--small .el-form-item__label {
    font-size: 14px;
    font-weight: bold;
    padding-left: 10px;
  }
  .des {
    margin-bottom: 18px;
    padding-left: 10px;
  }
  .titEdit {
    font-size: 14px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .jdInput {
    border: 1px solid rgba(121, 121, 121, 1);
    padding: 10px;
  }

  .titDiv {
    text-align: center;
  }
  .elInput {
    text-align: left;
  }

  .dialog-footer {
    display: block;
    text-align: center;
    margin-top: 18px;
  }

  .el-message-box_btns {
    padding-left: 5px 15px 0;
    display: flex;
    flex-direction: row-reverse;
    gap: 10px;
  }
}
</style>
